import styled from "styled-components";

const ContentSection = styled.section<{ $pcWidth?: string }>`
  margin: 0 auto;
  @media screen and (min-width: 961px) {
    width: ${({ $pcWidth }) => $pcWidth ?? "inherit"}; 
  }
`;
export default ContentSection;
